// MARK: ColumnDisplayPreferenceSeed
/**
 * Minimal column metadata for `extractColumnDisplayPreferences`.
 * Keeps `default-user-preferences` free of `"use client"` column modules.
 *
 * **Reuse scope:** Project-wide — table default display preferences.
 */
export type ColumnDisplayPreferenceSeed = {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
};

export const extractColumnDisplayPreferences = (
    columns: ColumnDisplayPreferenceSeed[] | null | undefined,
) => {
    return columns?.map?.((column) => ({
        id: String(column.id),
        ...column.defaultDisplayPreferences,
    })) || [];
};

export type ExtractedColumnDisplayPreferences = ReturnType<typeof extractColumnDisplayPreferences>;

/**
 * Example usage for populating DEFAULT_USER_DISPLAY_PREFERENCES:
 *
 * import { teacherColumns } from "@/view/teachers_table/search-config";
 * import { extractColumnsPreferences } from "@/lib/extract-columns-preferences";
 *
 * // In your DEFAULT_USER_DISPLAY_PREFERENCES:
 * pages: {
 *   pagePreferences: {
 *     teachers: {
 *       tableColumns: extractColumnsPreferences(teacherColumns),
 *       // ... other preferences
 *     }
 *   }
 * }
 *
 * This will automatically populate the default column preferences
 * from the column definitions in your search configs.
 */
